export type SortDirection = 'asc' | 'desc' | 'none';

export type SortOrder<T> = {
  [key in keyof Partial<T>]: SortDirection;
}

export function updateSort<T extends Object>(
  currentSort: SortOrder<T>,
  sortOption: keyof T,
): SortOrder<T> {

  if (!currentSort[sortOption]) {
    return {
      [sortOption]: 'asc',
      ...currentSort,
    }
  }

  switch (currentSort[sortOption]) {
    case "asc": {
      const { [sortOption]: _, ...rest } = currentSort;

      return {
        [sortOption]: "desc",
        ...rest,
      } as SortOrder<T>
    }

    case "desc": {
      const { [sortOption]: _, ...rest } = currentSort;
      
      return rest as SortOrder<T>;
    }

    default:
      return currentSort;
  }
}